import { SurveyButtonElement } from './button-element';
import { SurveyHeadingTextElement } from './heading-text-element';
import { SurveyImageElement } from './image-element';
import { SurveyLinkElement } from './link-element';
import { SurveyRating5StarsElement } from './rating-5-stars-element';
import { SurveySelectFacilityElement } from './select-facility-element';
import { SurveySingleSelectElement } from './single-select-element';
import { SurveyTextElement } from './text-element';
import { SurveyTextFieldElement } from './text-field-element';
import { SurveyTextareaFieldElement } from './textarea-field-element';
import { SurveyAiGeneratedTextFieldElement } from './ai-generated-text-field-element';
import { SurveyMultipleSelectElement } from './multiple-select-element';
import { SocialMediaShareElement } from './social-media-share-element';
import { CheckboxElement } from './checkbox-element';
import { AnswerDisplayElement } from './answer-display-element';

import { COMPONENT_TYPES } from '@/models/enums/component-types.enum';

/** Base config without SurveyGroupingElement to avoid circular dependency (grouping-element uses this and adds itself). */
export const BaseDiscriminatorConfig = () => [
  {
    value: AnswerDisplayElement,
    name: COMPONENT_TYPES.ANSWER_DISPLAY_ELEMENT,
  },
  {
    value: SurveyRating5StarsElement,
    name: COMPONENT_TYPES.RATING_5_STARS_ELEMENT,
  },
  {
    value: SurveyButtonElement,
    name: COMPONENT_TYPES.BUTTON,
  },
  {
    value: SurveyTextElement,
    name: COMPONENT_TYPES.TEXT_ELEMENT,
  },
  {
    value: SurveySelectFacilityElement,
    name: COMPONENT_TYPES.SELECT_FACILITY_ELEMENT,
  },
  {
    value: SurveyTextFieldElement,
    name: COMPONENT_TYPES.TEXT_FIELD_ELEMENT,
  },
  {
    value: SurveyTextareaFieldElement,
    name: COMPONENT_TYPES.TEXTAREA_FIELD,
  },
  {
    value: SurveyImageElement,
    name: COMPONENT_TYPES.IMAGE_ELEMENT,
  },
  {
    value: SurveyHeadingTextElement,
    name: COMPONENT_TYPES.HEADING_TEXT_ELEMENT,
  },
  {
    value: SurveyLinkElement,
    name: COMPONENT_TYPES.LINK_ELEMENT,
  },
  {
    value: SurveySingleSelectElement,
    name: COMPONENT_TYPES.SINGLE_BUTTON_SELECT_ELEMENT,
  },
  {
    value: SurveySingleSelectElement,
    name: COMPONENT_TYPES.SINGLE_SELECT_ELEMENT,
  },
  {
    value: SurveyAiGeneratedTextFieldElement,
    name: COMPONENT_TYPES.AI_GENERATED_TEXT_AREA_ELEMENT,
  },
  {
    value: CheckboxElement,
    name: COMPONENT_TYPES.CHECKBOX_ELEMENT,
  },
  {
    value: SurveyMultipleSelectElement,
    name: COMPONENT_TYPES.MULTIPLE_SELECT_ELEMENT,
  },
  {
    value: SocialMediaShareElement,
    name: COMPONENT_TYPES.SOCIAL_MEDIA_SHARE_ELEMENT,
  },
];
